import { FunctionCallRenderer } from 'components/chat-components/FunctionCallRenderer'
import { FunctionResultRenderer } from 'components/chat-components/FunctionResultRenderer'
import { TextRenderer } from 'components/chat-components/TextRenderer'
import { ThinkingRenderer } from 'components/chat-components/ThinkingRenderer'
import { VideoArtifactRenderer } from 'components/chat-components/VideoArtifactRenderer'
import { VideoSegmentRenderer } from 'components/chat-components/VideoSegmentRenderer'
import { VideoSideBySideRenderer } from 'components/chat-components/VideoSideBySideRenderer'
import { YouTubeVideoRenderer } from 'components/chat-components/YouTubeVideoRenderer'

import type { AgentContent, ContentRendererProperties } from 'components/chat-components/AgentMessage.types'
import type { ReactElement } from 'react'

type ContentRendererComponentProperties = {
  content: AgentContent
} & ContentRendererProperties

export const ContentRenderer = ({
  content,
  ...properties
}: ContentRendererComponentProperties): ReactElement | null => {
  /* --- Section 3: Derived Values --- */
  const renderedContent = (() => {
    switch (content.type) {
      case 'text': {
        return <TextRenderer content={content} />
      }
      case 'video_artifact': {
        return <VideoArtifactRenderer content={content} {...properties} />
      }
      case 'video_segment': {
        return <VideoSegmentRenderer content={content} {...properties} />
      }
      case 'video_side_by_side': {
        return <VideoSideBySideRenderer content={content} {...properties} />
      }
      case 'youtube_video': {
        return <YouTubeVideoRenderer content={content} />
      }
      case 'function_call': {
        return <FunctionCallRenderer content={content} />
      }
      case 'function_result': {
        return <FunctionResultRenderer content={content} />
      }
      case 'thinking': {
        return <ThinkingRenderer content={content} isThinkingOpen={properties.isThinkingOpen} />
      }
      default: {
        return null
      }
    }
  })()

  /* --- Section 6: Render --- */
  return renderedContent
}
